import { render, staticRenderFns } from "./RequestForCallListPage.vue?vue&type=template&id=bef3b776&scoped=true&"
import script from "./RequestForCallListPage.vue?vue&type=script&lang=js&"
export * from "./RequestForCallListPage.vue?vue&type=script&lang=js&"
import style0 from "./RequestForCallListPage.vue?vue&type=style&index=0&id=bef3b776&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef3b776",
  null
  
)

export default component.exports